import React, { FC, useState } from "react";
import { MenuIcon } from "./MenuIcon";
import { MenuList } from "./MenuList";
import { DownloadVideoModal } from "./DownloadVideo";
import { getFormattedUrl } from "./constants";

interface Props {
    title: string;
    id?: string | number;

    showBelow?: boolean;
    isDetailedPage?: boolean;
    onMenuClose?: (e: any) => void;

    downloadUrl?: string;
    onShare?: () => void;
    onEdit?: () => void;
    onAddToStory?: () => void;
    onRemoveFromStory?: () => void;
    onDelete?: () => void;
    onAddToVideoShortlist?: () => void;
    onRemoveFromVideoShortlist?: () => void;
    showReviewVideo?: boolean;
    onReviewVideo?: () => void;
    onUnapprove?: () => void;
    showUnapprove?: boolean;
    unapproveDisabled?: boolean;
    unapproveLabel?: string;
    showDownloadOptions?: boolean;
    showDelete?: boolean;
    onCopyPath?: () => void;
    onReimport?: () => void;
    onViewPreviousVersions?: () => void;
}

export const MenuDrawer: FC<Props> = ({ id, onMenuClose, ...props }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [showDownloadDialog, openDownloadDialog] = useState(false);
    const [downloadSource, setDownloadSource] = useState("");

    const menuId = `menu-box-${id || Math.random()}`;

    const hasOptions = Boolean(
        props.showReviewVideo ||
            props.onShare ||
            props.onEdit ||
            props.onAddToStory ||
            props.onUnapprove ||
            props.showUnapprove ||
            props.onAddToVideoShortlist ||
            props.onRemoveFromVideoShortlist ||
            props.onRemoveFromStory ||
            props.onCopyPath ||
            props.onReimport ||
            props.onViewPreviousVersions ||
            (props.showDownloadOptions && props.downloadUrl) ||
            (props.showDelete !== false && props.onDelete)
    );

    const showDownloadConfirmDialog = (format: string) => {
        const { downloadUrl } = props;

        if (!downloadUrl) return;
        openDownloadDialog(true);
        const url = getFormattedUrl(format, downloadUrl);
        if (url) setDownloadSource(url);
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            {hasOptions && <MenuIcon {...props} id={menuId} element={anchorEl} onClick={setAnchorEl} />}
            <MenuList
                {...props}
                anchorEl={anchorEl}
                id={menuId}
                onClose={(e) => {
                    setAnchorEl(null);
                    onMenuClose?.(e);
                }}
                onDownloadImage={showDownloadConfirmDialog}
                showReviewVideo={props.showReviewVideo}
                onReviewVideo={props.onReviewVideo}
                showDownloadOptions={props.showDownloadOptions}
            />
            <DownloadVideoModal
                open={showDownloadDialog}
                onClose={() => openDownloadDialog(false)}
                downloadSource={downloadSource}
            />
        </div>
    );
};
